// extracted by mini-css-extract-plugin
export default {"container":"Gp-z","ratingLayout":"Hp-z","ratingLabel":"Ip-z","nonInteractiveRatingLabel":"Jp-z"};